import type { FC } from "react";
import { useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import CancelButton from "../components/cancelButton/CancelButton";
import AsyncLoadingButton from "../components/asyncLoadingButton/AsyncLoadingButton";

interface Props {
  readonly open: boolean;
  readonly onCancel: () => void;
  readonly onConfirm: (note?: string) => Promise<void> | void;
}

const CompleteTaskDialog: FC<Props> = ({ open, onCancel, onConfirm }) => {
  const [note, setNote] = useState("");

  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="sm">
      <DialogTitle>Oznacz zadanie jako wykonane</DialogTitle>
      <DialogContent>
        <Stack
          spacing={2}
          sx={{
            marginTop: 1,
          }}
        >
          <Typography variant="body2">Opcjonalnie dodaj notatkę do zakończonego zadania</Typography>
          <TextField
            label="Notatka"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            multiline
            minRows={2}
            fullWidth
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <CancelButton
          onClick={() => {
            setNote("");
            onCancel();
          }}
        >
          Anuluj
        </CancelButton>
        <AsyncLoadingButton
          onClick={async () => {
            await onConfirm(note ? note : undefined);
            setNote("");
            onCancel();
          }}
        >
          Oznacz jako wykonane
        </AsyncLoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default CompleteTaskDialog;
